import React from "react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/Card/Card";

const NewCustomerReplacementEfficiencyChartSkeleton: React.FC = () => {
  return (
    <Card className="w-full animate-pulse">
      <CardHeader>
        <CardTitle className="h-6 w-80 bg-gray-300 dark:bg-gray-700 rounded mb-2" />
        <div className="h-4 w-96 bg-gray-300 dark:bg-gray-700 rounded" />
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="flex justify-center gap-4">
            <div className="h-4 w-32 bg-gray-300 dark:bg-gray-700 rounded" />
            <div className="h-4 w-32 bg-gray-300 dark:bg-gray-700 rounded" />
            <div className="h-4 w-32 bg-gray-300 dark:bg-gray-700 rounded" />
          </div>
          <div className="h-[450px] w-full bg-gray-300 dark:bg-gray-700 rounded" />
        </div>
      </CardContent>
    </Card>
  );
};

export default NewCustomerReplacementEfficiencyChartSkeleton;
